import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
} from "@headlessui/react";
import { Outlet } from "react-router-dom";
import { Link } from "react-router-dom";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import LogoEESW from "../assets/img/logo.svg"
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

const navigation = [
  { name: "Accueil", href: "/", current: false },
  { name: "Nos expertes", href: "/nos-expertes", current: false },
];

const navigation_mobile = [
  { name: "Accueil", href: "/", current: false },
  { name: "Nos expertes", href: "/nos-expertes", current: false },
  { name: 'Nos recommandations', href: '/strategie-retraite' },
  { name: 'Bilans retraite', href: '/bilan-retraite' },
  { name: 'Articulation chômage/retraite', href: '/articulation-chomage-retraite' },
  { name: 'Des solutions d\'optimisation', href: '/solutions-optimisation' },
  { name: 'Etudes comparatives expatriation', href: '/retour-expatriation' },
  { name: 'Des conférences spécifiques', href: '/nos-conferences' },
  { name: 'Liquidations de retraite', href: '/liquidations-retraite' },
]

const solutions = [
  { name: 'Nos recommandations', href: '/strategie-retraite' },
  { name: 'Bilans retraite', href: '/bilan-retraite' },
  { name: 'Articulation chômage/retraite', href: '/articulation-chomage-retraite' },
  { name: 'Des solutions d\'optimisation', href: '/solutions-optimisation' },
  { name: 'Etudes comparatives expatriation', href: '/retour-expatriation' },
  { name: 'Des conférences spécifiques', href: '/nos-conferences' },
  { name: 'Liquidations de retraite', href: '/liquidations-retraite' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  return (
    <>      
      <div className="min-h-full sticky top-0 z-10 shadow-xl">
        <Disclosure as="nav" className="border-b border-gray-200 bg-white">
          <div className="mx-auto max-w-full px-4 sm:px-2 flex">
            <div className="relative flex h-16 justify-between">
              <div className="relative z-10 flex px-2 lg:px-0">
                <div className="flex shrink-0 items-center">
                  <Link to="/">
                  <img
                      alt="Expertise&Benefits"
                      src={LogoEESW}
                      className="block h-52 w-auto lg:hidden"
                    />
                    <img
                      alt="Expertise&Benefits"
                      src={LogoEESW}
                      className="hidden h-52 w-auto lg:block"
                    />
                  </Link>
                </div>
            </div>
          </div>
          <div className="relative z-0 flex flex-1 items-center justify-center px-2 lg:absolute lg:inset-0">
            <div className="">             
                <div className="hidden md:-my-px md:ml-6 md:flex md:space-x-8">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      aria-current={item.current ? "page" : undefined}
                      className={classNames(
                        item.current
                          ? ""
                          : "text-gray-500 hover:text-gray-700",
                        "inline-flex items-center px-1 pt-1 text-lg font-medium"
                      )}
                    >
                      {item.name}
                    </Link>                    
                  ))}

                    <Popover className="inline-flex items-center  px-1 pt-1">
                    {({ close }) => (
                      <>
                      <PopoverButton className="inline-flex items-center  px-1  text-lg font-medium text-gray-500 hover:text-gray-700 focus:outline-none">
                        <span>Nos missions</span>
                        <ChevronDownIcon aria-hidden="true" className="size-5" />
                      </PopoverButton>

                      <PopoverPanel
                        transition
                        className="absolute  top-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
                      >
                        <div className="w-56 shrink rounded-xl bg-white p-4 text-sm/6 font-semibold text-gray-700 shadow-lg ring-1 ring-gray-900/5">
                          {solutions.map((item) => (
                            <Link key={item.name} to={item.href} className="block p-2" onClick={() => close()}>
                              {item.name}
                            </Link>
                          ))}
                        </div>
                      </PopoverPanel>
                   
                      </>
                    )}
                     </Popover>

                     <Link
                      to="#contact"
                      className="inline-flex items-center px-1 pt-1 text-lg font-medium text-gray-500 hover:text-gray-700"                      
                    >
                      Contact
                    </Link> 
                    
                </div>
              </div>
              <div className="-mr-2 flex items-center md:hidden">
                {/* Mobile menu button */}
                <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:ring-offset-2">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Ouvre le menu</span>
                  <Bars3Icon
                    aria-hidden="true"
                    className="block h-6 w-6 group-data-[open]:hidden"
                  />
                  <XMarkIcon
                    aria-hidden="true"
                    className="hidden h-6 w-6 group-data-[open]:block"
                  />
                </DisclosureButton>
              </div>
            </div>
          </div>

          <DisclosurePanel className="md:hidden">
            <div className="space-y-1 pb-3 pt-2">
              {navigation_mobile.map((item) => (
                <DisclosureButton
                  key={item.name}
                  as="a"
                  href={item.href}
                  aria-current={item.current ? "page" : undefined}
                  className={classNames(
                    item.current
                      ? ""
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-800",
                    "block border-l-4 py-2 pl-3 pr-4 text-base font-medium"
                  )}
                >
                  {item.name}
                </DisclosureButton>
              ))}              
            </div>
          </DisclosurePanel>
        </Disclosure>        
      </div>
      <Outlet />
    </>
  );
}
